<main id="site-main">
    <div class="inner-content">
        <section id="hero">
            <div class="content pb-md-5">
                <h1>سامانه ردیاب منطقه آزاد قصر‌شیرین</h1>
                <div class="w-100 my-3">
                    <button class="btn btn-primary btn-lg" routerLink="/login/profile">
                        <i class="fa fa-sign-in fa-lg me-2"></i>
                        ورود | ثبت‌نام
                    </button>
                </div>

                <h3> در صورت بروز مشکل در ثبت‌نام و یا پرداخت با شماره زیر تماس حاصل فرمایید</h3>
                <h4 class="">
                    <a href="tel:02191011566" class="fw-bold">
                        {{'021-91011566' | faNum}}
                    </a>
                </h4>
            </div>
        </section>
    </div>
</main>
<app-footer></app-footer>